const conf = require("../conf.json");
function removeOldData(data, timeZone) {
  // Get the current date and time in Dublin timezone
  const now = new Date().toLocaleString("en-US", { timeZone: timeZone });
  const currentDateTime = new Date(now);
  if (!Array.isArray(data)) return [];
  return data.filter((item) => {
    // Split the arrival_time into hours, minutes, and seconds
    const [hours, minutes, seconds] = item.arrival_time.split(":");

    // Get today's date in Dublin time
    const arrivalDate = new Date(currentDateTime);

    // Set the time based on arrival_time
    arrivalDate.setHours(hours, minutes, seconds);

    // Compare arrivalDate with the current time
    return arrivalDate >= currentDateTime;
  });
}
// function getFirstOnly(data) {
//   const seen = new Set();
//   const filtered = data.filter((item) => {
//     if (seen.has(item.trip_headsign)) return false;
//     seen.add(item.trip_headsign);
//     return true;
//   });
//   return filtered;
// }
function sortData(data, timeZone) {
  const now = new Date().toLocaleString("en-US", { timeZone: timeZone });
  const currentDateTime = new Date(now);
  if (!Array.isArray(data)) return [];
  const sortedData = data.sort((a, b) => {
    const [aHours, aMinutes, aSeconds] = a.adjusted_departure_time.split(":");
    const [bHours, bMinutes, bSeconds] = b.adjusted_departure_time.split(":");

    const aTime = new Date(currentDateTime);
    aTime.setHours(aHours, aMinutes, aSeconds);

    const bTime = new Date(currentDateTime);
    bTime.setHours(bHours, bMinutes, bSeconds);

    return aTime - bTime;
  });
  return sortedData;
}
exports.fetchTransportData = async (brand, email, id, timeZone) => {
  const url = `${
    conf.ServerHost
  }/v1/api/transport/data/${brand}/${email}/${id}?${Date.now()}`;
  const response = await fetch(url).catch((error) => {
    console.error("There was a problem with the fetch operation:", error);
    return [];
  });
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const res = await response.json(); // Parse JSON data from response
  // The API returns `data: []` when the media has no agency/stop configured.
  if (res.status && res.data && !Array.isArray(res.data)) {
    res.data.services = removeOldData(res.data.services, timeZone);
    res.data.services = sortData(res.data.services, timeZone);
    // console.log("res.data.services", res.data.services[0]);
    // res.data.services = res.data.services.filter((i) => i.direction_id == 0);
    // res.data.services = res.data.services.filter((i) =>
    //   i.trip_id.startsWith("4452_")
    // );
    //res.data.services = getFirstOnly(res.data.services);
    // console.log("res.data.services", JSON.stringify(res.data.services[0]));
  }
  return res;
};
exports.removeOldData = removeOldData;
